import { useState } from 'react';
import Modal from '../../components/common/Modal';
import SearchableSelect from '../../components/common/SearchableSelect';

const NIVEL_OPCOES = [
  { value: 1, label: 'Nível 1' },
  { value: 2, label: 'Nível 2' },
  { value: 3, label: 'Nível 3' },
];

export default function RequisitoForm({ subsecao, requisito, onClose, onSalvar }) {
  const grupoOpcoes = [
    { value: '', label: 'Sem grupo' },
    ...(subsecao?.grupos || []).map((g) => ({ value: g.id_grupo, label: g.nome })),
  ];

  const [codigo, setCodigo] = useState(requisito?.codigo || '');
  const [idGrupo, setIdGrupo] = useState(requisito?.id_grupo || '');
  const [nivel, setNivel] = useState(requisito?.nivel || 1);
  const [core, setCore] = useState(requisito?.core || false);
  const [texto, setTexto] = useState(requisito?.texto || '');
  const [orientacoes, setOrientacoes] = useState(requisito?.orientacoes || '');
  const [ativo, setAtivo] = useState(requisito?.ativo ?? true);
  const [enviando, setEnviando] = useState(false);
  const [erro, setErro] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErro('');
    setEnviando(true);
    try {
      if (requisito) {
        await onSalvar({ nivel: Number(nivel), core, texto, orientacoes: orientacoes || null, ativo });
      } else {
        await onSalvar({
          id_subsecao: subsecao.id_subsecao,
          id_grupo: idGrupo || null,
          codigo,
          nivel: Number(nivel),
          core,
          texto,
          orientacoes: orientacoes || null,
        });
      }
      onClose();
    } catch (err) {
      setErro(err?.response?.data?.detail || 'Não foi possível salvar.');
    } finally {
      setEnviando(false);
    }
  };

  return (
    <Modal
      titulo={requisito ? `Editar requisito ${requisito.codigo}` : `Novo requisito — Subseção ${subsecao.numero}`}
      onClose={onClose}
      largura={560}
    >
      <form className="am-form" onSubmit={handleSubmit}>
        {!requisito && (
          <>
            <label className="am-field">
              <div className="am-field__label-row">
                <span className="am-field__label">Código</span>
              </div>
              <input value={codigo} onChange={(e) => setCodigo(e.target.value)} placeholder={`${subsecao.numero}.1`} required />
            </label>
            <div>
              <div className="am-field__label mb-1">Grupo de requisitos</div>
              <SearchableSelect options={grupoOpcoes} value={idGrupo} onChange={setIdGrupo} />
            </div>
          </>
        )}

        <div className="am-form__row">
          <div>
            <div className="am-field__label mb-1">Nível</div>
            <SearchableSelect options={NIVEL_OPCOES} value={nivel} onChange={(v) => setNivel(v)} required />
          </div>
          <label className="am-field d-flex align-items-center" style={{ paddingTop: 18, paddingBottom: 18 }}>
            <button
              type="button"
              className="am-checkbox"
              onClick={() => setCore((v) => !v)}
            >
              <span className={`am-checkbox__box${core ? ' is-checked' : ''}`}>
                {core && <span className="ms">check</span>}
              </span>
              Requisito CORE
            </button>
          </label>
        </div>

        <label className="am-field">
          <div className="am-field__label-row">
            <span className="am-field__label">Texto do requisito</span>
          </div>
          <textarea rows={3} value={texto} onChange={(e) => setTexto(e.target.value)} required />
        </label>

        <label className="am-field">
          <div className="am-field__label-row">
            <span className="am-field__label">Orientações (opcional)</span>
          </div>
          <textarea rows={3} value={orientacoes} onChange={(e) => setOrientacoes(e.target.value)} />
        </label>

        {requisito && (
          <button type="button" className="am-checkbox" onClick={() => setAtivo((v) => !v)}>
            <span className={`am-checkbox__box${ativo ? ' is-checked' : ''}`}>
              {ativo && <span className="ms">check</span>}
            </span>
            Requisito ativo no catálogo
          </button>
        )}

        {erro && <div className="am-field__error">{erro}</div>}

        <div className="am-form__actions">
          <button type="button" className="am-btn am-btn-outline" onClick={onClose}>
            Cancelar
          </button>
          <button type="submit" className="am-btn am-btn-dark" disabled={enviando}>
            {enviando ? 'Salvando...' : 'Salvar'}
          </button>
        </div>
      </form>
    </Modal>
  );
}
